export enum MFAErrorCodes {
  UNKNOWN = 'UNKNOWN',
  USER_CANCELLED = 'USER_CANCELLED',

  CHANNEL_UNSUPPORTED = 'CHANNEL_UNSUPPORTED',

  /**
   * The given challengeId and challengeCode failed the challenge.
   */
  CHALLENGE_FAILED = 'CHALLENGE_FAILED',

  /**
   * The given data did not match the initial request.
   */
  CHALLENGE_MISMATCH = 'CHALLENGE_MISMATCH',

  /**
   * The given challengeId is either expired or unknown.
   */
  EXPIRED_OR_UNKNOWN = 'EXPIRED_OR_UNKNOWN',

  /**
   * The given challengeId is either expired or unknown.
   */
  EXPIRED = 'EXPIRED',

  INVALID_VERIFY_REQUEST = 'INVALID_VERIFY_REQUEST',

  /**
   * The maximum number of attempts to request a challenge has been reached.
   */
  MAXIMUM_SEND_ATTEMPTS_REACHED = 'MAXIMUM_SEND_ATTEMPTS_REACHED',

  /**
   * The maximum number of attempts to challenge a code has been reached.
   */
  MAXIMUM_CHECK_ATTEMPTS_REACHED = 'MAXIMUM_CHECK_ATTEMPTS_REACHED',

  /**
   * One or more given parameters are invalid. For example, an invalid email.
   */
  INVALID_PARAMETER = 'INVALID_PARAMETER',
}
